import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FileFormFields, FileTypeDisplayString } from 'v2/utils/drmFileUtils';
import { GeneralSelect } from 'v2/form/CustomSelectors/GeneralSelect';
import { FileType } from 'v2/models';

const options = Object.values(FileType).map((key) => ({
  label: FileTypeDisplayString[key],
  value: key,
}));

const FileTypeDropdown = () => {
  const { control } = useFormContext<FileFormFields>();

  return (
    <Controller
      name="type"
      control={control}
      rules={{
        required: true,
      }}
      render={({ field: { onChange, value } }) => {
        const selected = options.find((option) => option.value === value);

        return (
          <GeneralSelect
            options={options}
            selectedOption={selected}
            handleChange={(option) => onChange(option?.value)}
            customStyles={{
              control: {
                width: '100%',
                borderColor: 'var(--light-gray)',
              },
              dropdownIndicator: {
                right: '10px',
                justifyContent: 'flex-end',
              },
            }}
          />
        );
      }}
    />
  );
};

export default FileTypeDropdown;
